import { FC } from 'react';
import ActionsButtonDetailsPage from 'components/Shared/ActionsButtonDetailsPage';
import ActionGroupItemLabel from 'components/Shared/ActionsButtonDetailsPage/ActionGroupItemLabel';
import { TMenuProps } from '@idaho-aeyc/ui-kit';
import { TExportDropdownProps } from './ExportDropdown.types';

const ExportDropdown: FC<TExportDropdownProps> = ({
  onExportAll,
  onExportSelected,
  isExporting = false,
  disabled = false,
}) => {
  const items: TMenuProps['items'] = [
    {
      key: 'export_selected',
      disabled: isExporting || disabled,
      label: (
        <ActionGroupItemLabel
          onClick={onExportSelected}
          label="Export Selected"
          disabled={isExporting || disabled}
        />
      ),
    },
    {
      key: 'export_all',
      disabled: isExporting || disabled,
      label: (
        <span data-cy="btn_export">
          <ActionGroupItemLabel
            onClick={onExportAll}
            label="Export All"
            disabled={isExporting || disabled}
          />
        </span>
      ),
    },
  ];

  return <ActionsButtonDetailsPage items={items} label="Export" />;
};

export default ExportDropdown;
